import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<ScreenConfigEditor @config={{@model}} />\n",{ moduleName: "bullitt-time-live/templates/event/screen-config-editor.hbs" })